import React from 'react';
import styled from "styled-components";
import Icon from "@atoms/icon";
import StarIcon from '@icons/star.svg';

function Stars({rate = 0}) {
    let stars = [];
    if (rate > 5) {
        rate = 5;
    }
    for (let star = rate; star < 5; star++) {
        stars.push(<Icon><StarIcon/></Icon>);
    }
    for (let star = 1; star <= rate; star++) {
        stars.push(<Icon><StarIcon className="active"/></Icon>);
    }



    return (
        <Container>
            {stars}
        </Container>
    )
}

export default Stars;

// styles
const Container = styled.div`
    line-height: 0;
    
    .icons {
        width: 16px;
        margin-right: 3px;
        
        svg {
          &.active {
            path {
                fill: ${props => props.theme.secondary};
                stroke: ${props => props.theme.secondary};
            }
          }
          path {
            stroke-width: 1px;
          }
        }
        
        &:first-child {
            margin-right: 0;
        }
    }
`;